module.exports = __webpack_public_path__ + "img/valeria.a90f7bb5.jpg";